import { RichLabel } from "@patient-watch/forms";
import { formComponents as fc } from "@/features/i18n/formComponents";
import { formPageFooterActionsClass, formPageFooterFrameClass } from "./formPageLayout";

interface Props {
    instructions: string;
    startLabel: string;
    backLabel: string;
    onStart: () => void;
    onBack: () => void;
}

/** Instructions shown once on their own screen before the first question. */
const FormIntroScreen = ({ instructions, startLabel, backLabel, onStart, onBack }: Props) => {
    return (
        <div className="flex flex-col flex-1 min-h-0">
            <div
                className="flex-1 mt-2 min-h-0 overflow-y-auto text-slate-800 dark:text-slate-200 text-lg text-left leading-relaxed whitespace-pre-line"
                data-testid="form-intro-instructions"
            >
                <RichLabel>{instructions}</RichLabel>
            </div>

            <div className={formPageFooterFrameClass}>
                <div className={formPageFooterActionsClass}>
                    <div className="footer-actions-primary">
                        <fc.NextButton
                            className="px-4"
                            label={startLabel}
                            onClick={onStart}
                            data-testid="footer-primary-button"
                        />
                    </div>
                    <div className="footer-actions-secondary">
                        <fc.BackButton
                            className="px-4 w-full whitespace-nowrap"
                            label={backLabel}
                            onClick={onBack}
                            data-testid="footer-secondary-button"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormIntroScreen;
